module.exports = __webpack_public_path__ + "dfb9f7486d435bff093652d677b0a59a.svg";